/** Hourly report: models backed by usage **aggregate** (`report/data/usage/aggregate`). */
export const HOURLY_REPORT_AGGREGATE_MODELS = new Set([
  "tag.rhw",
  "tag.h2o",
  "tag.wmd",
  "tag.rhe",
  "tag.opt",
  "stron.gas",
]);

/**
 * Hourly report: models backed by averaged readings (same semantics as POST
 * `data/average/timeseries`: `type` temperature | level | humidity).
 */
export const HOURLY_REPORT_AVERAGE_TIMESERIES_MODELS = new Set([
  "tag.tmp",
  "tag.tmo",
  "lora.nanotag",
  "lora.tmp",
  "lora.humidity",
  "tag.lvl",
]);

const BASE_AGGREGATE_SENSORS = [
  "water-meter",
  "meterreading",
  "forwardticks",
  "otherticks",
  "cumulative-odo",
] as const;

export type TimeseriesAverageMetric = "temperature" | "level" | "humidity";

export type HourlyReportCase4Resolution =
  | { mode: "aggregate"; sensors: readonly string[] }
  | { mode: "average_timeseries"; metric: TimeseriesAverageMetric };

function modelToAverageMetric(model: string): TimeseriesAverageMetric {
  if (model === "tag.lvl") return "level";
  if (model === "lora.humidity") return "humidity";
  return "temperature";
}

/**
 * Routes Hourly Report (report type 4) to usage aggregate vs. averaged timeseries
 * based on the selected device's `model` string.
 */
export function resolveHourlyReportCase4(
  deviceModel?: string | null
): HourlyReportCase4Resolution {
  if (
    deviceModel &&
    HOURLY_REPORT_AVERAGE_TIMESERIES_MODELS.has(deviceModel)
  ) {
    return {
      mode: "average_timeseries",
      metric: modelToAverageMetric(deviceModel),
    };
  }
  if (deviceModel && HOURLY_REPORT_AGGREGATE_MODELS.has(deviceModel)) {
    return {
      mode: "aggregate",
      sensors: [...BASE_AGGREGATE_SENSORS],
    };
  }
  // Legacy / unknown model: previous adhoc behaviour (aggregate + temp-meter)
  return {
    mode: "aggregate",
    sensors: [...BASE_AGGREGATE_SENSORS, "temp-meter"],
  };
}
